<app-breadcrumb [master]="'OCK'" [parentName]="'Raporty'" [name]="'Użytkownicy'"></app-breadcrumb>
<div class="ock-user-list-container">

  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="ock-user-list-filters">
  </form>

  <div class="ock-user-list-buttons">
    <button *ngIf="(userPermissions | async).ock.create" [disabled]="!(userPermissions | async)?.ock.create" mat-raised-button class="report-button" (click)="downloadReport()">
      <mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
  </div>

  <table mat-table [dataSource]="dataSource">

    <!-- Position Column -->
    <ng-container matColumnDef="fullName">
      <th mat-header-cell *matHeaderCellDef> Imię i nazwisko </th>
      <td mat-cell *matCellDef="let element">
          {{element.firstName}} {{element.lastName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef> Status </th>
      <td mat-cell *matCellDef="let element">
        {{element.active === 1 ? 'Aktywny' : 'Nieaktywny'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef> Email </th>
      <td mat-cell *matCellDef="let element">
        {{element.email}}
      </td>
    </ng-container>

    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef> Numer telefonu </th>
      <td mat-cell *matCellDef="let element">
        {{element.phone }}
      </td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef> Firma </th>
      <td mat-cell *matCellDef="let element">
        {{ element.shortName  }}
      </td>
    </ng-container>

    <ng-container matColumnDef="nip">
      <th mat-header-cell *matHeaderCellDef> NIP </th>
      <td mat-cell *matCellDef="let element">
        {{element.nip}}
      </td>
    </ng-container>



    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>

